import { IPagination } from "../models/IPagination";
import { IUser } from "../models/IUser";
import { AdminRole } from "../types/adminRoles";
import api from "../services/api";

export const searchUsers = (
  search: string,
  pageNumber: number = 1,
  pageSize: number = 10,
  sortBy?: "firstName" | "createdAt",
  sortOrder?: "asc" | "desc"
): Promise<{
  data: { items: IUser[]; pagination: IPagination };
}> => {
  const params: Record<string, any> = {
    pageNumber,
    pageSize,
    sortBy: sortBy || "createdAt",
    sortOrder: sortOrder || "desc",
  };

  if (search) params.search = search;

  return api.get("User/search", {
    params,
  });
};

export const getUsersWithAdminRoles = (): Promise<{ data: IUser[] }> => api.get("User/admin-roles");

export const assignAdminRole = (data: { userId: string; role: AdminRole }) => api.post("User/admin-role/assign", data);

export const removeAdminRole = (data: { userId: string; role: AdminRole }) => api.post("User/admin-role/remove", data);

export const getUserById = (id: string): Promise<{ data: IUser }> => api.get(`User/${id}`);
